import { RenameFolderModal } from 'ui/indexPages/modals/RenameFolderModal/RenameFolderModal';
import { useModalContext } from 'utils/contexts/modal';
import { useRenameListFolderMutation } from '../../hooks/folders/useRenameListFolderMutation';
import { useListsContext, useSelectionContext } from '../../contexts';
import { MAX_FOLDER_NAME_LENGTH } from '../../constants';

export const RenameListFolderModal = () => {
  const { hideModal } = useModalContext();
  const { refetch, isLoading } = useListsContext();
  const { active } = useSelectionContext();

  const [renameListFolder] = useRenameListFolderMutation({
    folder: active[0],
    onSuccess: () => {
      refetch();
    },
    onComplete: () => {
      hideModal();
    },
  });

  return (
    <RenameFolderModal
      folderName={active[0]?.name ?? ''}
      onClose={hideModal}
      isLoading={isLoading}
      maxNameLength={MAX_FOLDER_NAME_LENGTH}
      onConfirm={(newName) => {
        if (active[0]) {
          renameListFolder({ variables: { newName, folderId: active[0].id } });
        }
      }}
    />
  );
};
